import { api } from "#/lib/api-client";
import type {
  RoleCreateRequest,
  RoleResponse,
  RoleUpdateRequest,
} from "./types";

export const roleApi = {
  async list(): Promise<RoleResponse[]> {
    const { data } = await api.get<RoleResponse[]>("/api/hr/roles");
    return data;
  },

  async getById(id: number): Promise<RoleResponse> {
    const { data } = await api.get<RoleResponse>(`/api/hr/roles/${id}`);
    return data;
  },

  async create(payload: RoleCreateRequest): Promise<RoleResponse> {
    const { data } = await api.post<RoleResponse>("/api/hr/roles", payload);
    return data;
  },

  async update(id: number, payload: RoleUpdateRequest): Promise<RoleResponse> {
    const { data } = await api.put<RoleResponse>(
      `/api/hr/roles/${id}`,
      payload,
    );
    return data;
  },

  async options(): Promise<RoleResponse[]> {
    const { data } = await api.get<RoleResponse[]>("/api/hr/roles/options");
    return data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/api/hr/roles/${id}`);
  },
};
